import GroupOperationDialog from './GroupOperationDialog';

export default GroupOperationDialog;
export type { GroupOperationNounForms, IGroupOperationItem } from './GroupOperationDialog.types';
export { countWithNoun } from './groupOperationText';
